import { SupportPageController } from "./supportPage";

const supportPage = new SupportPageController();

// Keep the public global while external consumers of the legacy entry cannot be ruled out.
window.SupportPage = supportPage;

document.addEventListener("DOMContentLoaded", () => {
  window.SupportPage?.init();
});
